import { useState } from "react";
import { useSelector } from "react-redux";

import { currentUserIDSelector } from "@/models/selectors/user";
import { getMySubmissions } from "@/services";

const useGetMySubmission = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [jobStatus, setJobStatus] = useState(true);
  // const [firstLoad, setFirstLoad] = useState(true);

  const currentUserID = useSelector(currentUserIDSelector);

  const doFetch = async () => {
    setIsLoading(true);

    const result = await getMySubmissions(currentUserID, jobStatus);

    setIsLoading(false);

    setData(result.data.data);
  };

  return { isLoading, data, doFetch, jobStatus, setJobStatus };
};

export { useGetMySubmission };
